const cols = [
  {
    title: '素材ID',
    key: 'imageId',
    fixed: true,
    width: 54
  },
  {
    title: '素材',
    key: 'coverUrl',
    fixed: true,
    width: 108
  },
  {
    title: '素材名称',
    key: 'imageName',
    fixed: true,
    width: 108
  },
  {
    title: '操作',
    key: 'control',
    fixed: true,
    width: 88,
    exclude_export: true
  },
  {
    title: '素材类型',
    key: 'type',
    type: 'basic',
    width: 70
  },
  {
    title: '营销主题标签',
    key: 'typeLabelNames',
    type: 'basic',
    width: 86,
    overflow: true
  },
  {
    title: '一级素材样式',
    key: 'imageStyle1LabelNames',
    type: 'basic',
    width: 86,
    overflow: true
  },
  {
    title: '二级素材样式',
    key: 'imageStyle2LabelNames',
    type: 'basic',
    width: 86,
    overflow: true
  },
  {
    title: '3D视频源',
    key: 'videoLabelNames',
    type: 'basic',
    width: 72,
    overflow: true
  },
  {
    title: '内容标签',
    key: 'labelNames',
    type: 'basic',
    width: 72,
    overflow: true
  },
  {
    title: '来源',
    key: 'source',
    type: 'basic',
    width: 72
  },
  {
    title: '设计者',
    key: 'designerName',
    type: 'basic',
    width: 62
  },
  {
    title: '模型地编',
    key: 'tcmName',
    type: 'basic',
    width: 62,
    overflow: true
  },
  {
    title: '动画设计',
    key: 'animationName',
    type: 'basic',
    width: 62,
    overflow: true
  },
  {
    title: '渲染设计',
    key: 'renderName',
    type: 'basic',
    width: 62,
    overflow: true
  },
  {
    title: '策划者',
    key: 'plannerName',
    type: 'basic',
    width: 62,
    overflow: true
  },
  {
    title: '游戏',
    key: 'gameNames',
    type: 'basic',
    width: 72,
    overflow: true
  },
  {
    title: '上传时间',
    key: 'uploadTime',
    type: 'basic',
    width: 72
  },
  {
    title: '消耗计算起始日',
    key: 'lauchTime',
    type: 'basic',
    width: 96
  },
  {
    title: '有效计划数',
    key: 'hasDataCount',
    type: 'basic',
    width: 72
  },
  {
    title: '头条评分',
    key: 'intelligentScore',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '腾讯评分',
    key: 'intelligentScore2',
    sortable: 'custom',
    type: 'basic',
    width: 94
  },
  {
    title: '展示',
    key: 'pv',
    sortable: 'custom',
    type: 'basic',
    width: 78
  },
  {
    title: '点击',
    key: 'clickNum',
    sortable: 'custom',
    type: 'basic',
    width: 78
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    type: 'basic',
    width: 76
  },
  {
    title: '7日消耗',
    key: 'amount7',
    type: 'basic',
    sortable: 'custom',
    width: 76
  },
  {
    title: '30日消耗',
    key: 'thirtyDayAmount',
    type: 'basic',
    sortable: 'custom',
    width: 80
  },
  {
    title: '新增30日创角',
    key: 'createRole30',
    width: 95,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '点击单价',
    key: 'clickUnitPrice',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    type: 'report',
    width: 72
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    type: 'report',
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    type: 'report',
    width: 82
  },
  {
    title: '激活率',
    key: 'activeRate',
    sortable: 'custom',
    type: 'report',
    width: 76
  },
  {
    title: '新创角付费数',
    key: 'payRoleUserNum',
    sortable: 'custom',
    type: 'report',
    width: 108
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    sortable: 'custom',
    type: 'report',
    width: 108
  },
  {
    title: '新创角付费成本',
    key: 'newPayCost',
    sortable: 'custom',
    type: 'report',
    width: 108
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    type: 'report',
    width: 108
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    sortable: 'custom',
    type: 'report',
    width: 124
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    sortable: 'custom',
    type: 'report',
    width: 114
  },
  {
    title: '播放数',
    key: 'totalPlay',
    type: 'analysis',
    width: 58
  },
  {
    title: '有效播放数',
    key: 'validPlay',
    type: 'analysis',
    width: 72
  },
  {
    title: '有效播放率',
    key: 'validPlayRate',
    type: 'analysis',
    width: 72
  },
  {
    title: '播放完成数',
    key: 'playOver',
    type: 'analysis',
    width: 72
  },
  {
    title: '播完率',
    key: 'playOverRate',
    type: 'analysis',
    width: 58
  },
  {
    title: '3s播放率',
    key: 'playDuration3sRate',
    type: 'analysis',
    width: 66
  },
  {
    title: '25%进度播放率',
    key: 'play25FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '50%进度播放率',
    key: 'play50FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '75%进度播放率',
    key: 'play75FeedBreakRate',
    type: 'analysis',
    width: 96
  },
  {
    title: '平均单次播放时长(头条)',
    key: 'averagePlayTimePerPlay',
    type: 'analysis',
    width: 106
  },
  {
    title: '平均单次有效播放时长(腾讯)',
    key: 'averageValidPlayTimePerPlay',
    type: 'analysis',
    width: 106
  },
  {
    title: '分享数',
    key: 'videoShare',
    type: 'analysis',
    width: 88
  },
  {
    title: '评论数',
    key: 'videoComment',
    type: 'analysis',
    width: 88
  },
  {
    title: '点赞数',
    key: 'videoLike',
    type: 'analysis',
    width: 88
  },
  {
    title: '不感兴趣数',
    key: 'dislike',
    type: 'analysis',
    width: 88
  },
  {
    title: '新增关注数',
    key: 'follow',
    type: 'analysis',
    width: 88
  },
  {
    title: '私信数',
    key: 'messageAction',
    type: 'analysis',
    width: 88
  },
  {
    title: '举报数',
    key: 'report',
    type: 'analysis',
    width: 88
  },
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    type: 'report',
    show: true,
    width: 58
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    type: 'report',
    show: true,
    width: 58
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    type: 'report',
    show: true,
    width: 58
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    type: 'report',
    show: true,
    width: 62
  },

  {
    title: '1日ROI',
    key: 'createRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    width: 98
  },

  {
    title: '3日ROI',
    key: 'createRoleRoi3d',
    type: 'report',
    sortable: 'custom',
    width: 98
  },

  {
    title: '7日ROI',
    key: 'createRoleRoi7d',
    type: 'report',
    sortable: 'custom',
    width: 98
  },

  {
    title: '15日ROI',
    key: 'createRoleRoi15d',
    type: 'report',
    sortable: 'custom',
    width: 98
  },

  {
    title: '30日ROI',
    key: 'createRoleRoi30d',
    type: 'report',
    sortable: 'custom',
    width: 98
  },

  {
    title: '创角次留',
    key: 'createRoleTwoDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角3留',
    key: 'createRoleThreeDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角4留',
    key: 'createRoleFourDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角5留',
    key: 'createRoleFiveDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角6留',
    key: 'createRoleSixDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角7留',
    key: 'createRoleSevenDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角10留',
    key: 'createRoleTenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角15留',
    key: 'createRoleFifteenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角30留',
    key: 'createRoleThirtyDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角2日LTV',
    key: 'createRoleTwoDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角3日LTV',
    key: 'createRoleThreeDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角4日LTV',
    key: 'createRoleFourDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角5日LTV',
    key: 'createRoleFiveDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角6日LTV',
    key: 'createRoleSixDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角7日LTV',
    key: 'createRoleSevenDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角10日LTV',
    key: 'createRoleTenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角15日LTV',
    key: 'createRoleFifteenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角30日LTV',
    key: 'createRoleThirtyDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费次留',
    key: 'twoDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费3留',
    key: 'threeDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费4留',
    key: 'fourDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费5留',
    key: 'fiveDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费6留',
    key: 'sixDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费7留',
    key: 'sevenDayNewPayRoleRetain',
    type: 'other',
    width: 82
  },
  {
    title: '创角付费10留',
    key: 'tenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费15留',
    key: 'fifteenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费30留',
    key: 'thirtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费45留',
    key: 'fortyFiveDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费60留',
    key: 'sixtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费75留',
    key: 'seventyFiveDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费90留',
    key: 'ninetyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费120留',
    key: 'oneHundredAndTwentyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费150留',
    key: 'oneHundredAndFiftyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费180留',
    key: 'oneHundredAndEightyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费210留',
    key: 'twoHundredAndTenDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费240留',
    key: 'twoHundredAndFortyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费270留',
    key: 'twoHundredAndSeventyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费300留',
    key: 'threeHundredDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费330留',
    key: 'threeHundredAndThirtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  },
  {
    title: '创角付费360留',
    key: 'threeHundredAndSixtyDayNewPayRoleRetain',
    type: 'other',
    width: 92
  }
]

export default cols
export const materialAnalysisCols = cols.filter((item) => !['激活次留', '激活3留', '激活7留', '激活30留'].includes(item.title))
